export default "__VITE_ASSET__XmIDeOd7__"